import types from './constants'

export default {
  [types.PARENT_PENDING]: () => ({
   type: types.PARENT_PENDING,
  }),
  [types.PARENT_COMPLETE]: (report) => ({
   type: types.PARENT_COMPLETE,
   report
  }),
  [types.PARENT_ERROR]: (error) => ({
   type: types.PARENT_ERROR,
   error
  }),
  [types.SET_PRINT_LANGUAGE]: (language) => ({
   type: types.SET_PRINT_LANGUAGE,
   language
  }),
}